import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";

interface NavigationBackButtonProps {
    label: string;
    onClick: () => void;
    description?: string;
    bridgeId?: string;
    testId?: string;
}

/** Shared product-navigation back action used in page headers. */
export function NavigationBackButton({
    label,
    onClick,
    description = `Navigate ${label.toLowerCase()}`,
    bridgeId,
    testId
}: NavigationBackButtonProps) {
    return (
        <Box
            data-ui-bridge={bridgeId}
            data-ui-label={label}
            data-ui-role="button"
            data-ui-group="navigation"
            data-ui-description={description}
        >
            <Tooltip title={label} placement="bottom" arrow>
                <IconButton
                    aria-label={label}
                    data-testid={testId}
                    onClick={onClick}
                    sx={{
                        width: 40,
                        height: 40,
                        color: "primary.main",
                        "&:hover": { bgcolor: "primary.main", color: "#FFFFFF" }
                    }}
                >
                    <ArrowBackIcon sx={{ fontSize: 20 }} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
